<template>
    <div>
      <div class=" row mb-2" >
         <label class="col-sm-4 lh40 text-lr"><i
          v-if=" Data.data.c_priority==='S'"
          class="fa fa-asterisk text-danger font10 ml-1"
          aria-hidden="true"></i>{{ Data.data.c_name }}：</label>
            <div class="col-sm-7 ">
                <el-date-picker @change="$get_function(Data,value),$get_function({'data':{'c_id':Data.data.c_id+1},'obj':''},value)"
                                :picker-options="Data.attr.showAll===true?pickerOptions2:pickerOptions"
                                v-model="value" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期时间">
                </el-date-picker>
            </div>{{ Data.data.c_unit }}
      </div>
    </div>
</template>

<script>

export default {
    name: "dateAndTime",
    props: [
        'Data',
    ],
    data() {
        return {
            value: this.Data.data.c_value,
           pickerOptions: {
                    disabledDate(time) {
                        return time.getTime()<Date.now();
                    },
                },
            pickerOptions2:{
                disabledDate() {
                        return false
                    },
            },
        }
    },
    created() {
    },
    methods: {}
}
</script>

<style scoped>
/deep/.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
}
</style>
